import matchHeight from 'jquery-match-height';

import inview from 'jquery-inview';


$(function() {
	$('.sankakouList li a').matchHeight({
        byRow: false
    });
});


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
*スマホメニューボタン
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
function spToggleBtn_func() {
    //デバイス判定（タッチが有効か否か）
    var isTouchDevice = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
    //デバイス判定によるイベントの決定
    var eventType = (isTouchDevice) ? 'touchend' : 'click';
    $(".sp_btn").on("click", function () {
        $("html").toggleClass("spmenu-open");

    });

    var window_width = window.innerWidth;
    var timer = false;

    $(window).on('orientationchange', function () {
        var resize_width = window.innerWidth;
        if (window_width != resize_width) {
            if (timer !== false) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                $("html").removeClass("spmenu-open");
              
                window_width = resize_width;
            }, 100);
        }
    });

    //メニューの中クリックしたらとじる
    $('#sp-menu a').on('click', function () {
      
        $("html").removeClass("spmenu-open");

    });
    // 表示したポップアップ以外の部分をクリックしたとき
    $(document).on('click touchend', function (event) {
        if ($("html").hasClass("spmenu-open")) {
       if (!$(event.target).closest("#sp-naviArea").length && !$(event.target).closest("#header").length) {
          
         $("html").removeClass("spmenu-open");

       }
    }
    });
}

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* back_to_top
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
function backtotop_func() {
"use strict";
var win = $(window),
back_to_top = $('.backtotop'),
showClass = 'backtotop-visible',
scroll_top_duration = 700;
    win.on('load scroll', function() {
        var contactWrapOffsetTop = document.getElementById('footer').offsetTop,
            thisScrollTop = $(this).scrollTop(),
            scrollBottom = win.scrollTop() + win.height();         
        if (thisScrollTop > 500) {
            if (scrollBottom >= contactWrapOffsetTop) {
                back_to_top.removeClass(showClass);
            } else {
                back_to_top.addClass(showClass);
            }
        } else {
            back_to_top.removeClass(showClass);
        }
    });
    var clickEventType = ((window.ontouchstart !== null) ? 'click' : 'touchstart');
    back_to_top.on(clickEventType, function() {
        $('body,html').animate({
            scrollTop: 0,
        }, scroll_top_duration);
    });
}

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* smooth scroll
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
function smooth_scroll_func() {
   var headerHeight = $("#header").outerHeight();
 var urlHash = location.hash;
 if (urlHash) {
  $("body,html").stop().scrollTop(0);
  setTimeout(function () {
   var target = $(urlHash);
   var position = target.offset().top - headerHeight;
   $("body,html").stop().animate({ scrollTop: position }, 0);
  }, 100);
   return false;
 }
 $('a[href^="#"]').on("click", function () {
    var headerHeight = $("#header").outerHeight();
  var href = $(this).attr("href");
  var target =  $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top - headerHeight;
  $("body,html").stop().animate({ scrollTop: position }, 500, "swing");
   return false;
 });
}



/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * inview
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
function inview_func() {
    var inviewDeferred = $.Deferred();

    if ($('#wrapper').hasClass('inview--start')) {
        inviewDeferred.resolve();
    }
    inviewDeferred.done(function() {


        inview_fadeIn(); //フェードインclass名（inview_fadeIn）
        inview_fadeInUp(); //フェードインclass名（inview_fadeInUp）
        inview_zoomIn();
        effectFlug(); //inviewでフラグ立てたいとき用class名（effectFlug）をつけたものに（effect_start）クラスがつく
    });

    function effectFlug() {
        $('.effectFlug').one('inview', function(event, isInView) {

            $(this).addClass('effectFlug--now');
            if (isInView) {
                $('.effectFlug--now').each(function(i) {
                    $(this).delay(i * 200).queue(function() {
                        $(this).addClass('effect_start').removeClass('effectFlug--now').dequeue();
                    });
                });
            }
        });
    }

    function inview_fadeIn() {
        $('.inview_fadeIn').one('inview', function(event, isInView) {
            $(this).addClass('inview_fadeIn--now');
            if (isInView) {
                $('.inview_fadeIn--now').each(function(i) {
                    $(this).delay(i * 100).queue(function() {
                        $(this).addClass('animated animate__fadeIn').removeClass('inview_fadeIn--now inview_fadeIn').dequeue();
                    });
                });
            }
        });
    }

    function inview_fadeInUp() {
        $('.inview_fadeInUp').one('inview', function(event, isInView) {
            $(this).addClass('inview_fadeInUp--now');
            if (isInView) {
                $('.inview_fadeInUp--now').each(function(i) {
                    $(this).delay(i * 100).queue(function() {
                        $(this).addClass('animated animate__fadeInUp').removeClass('inview_fadeInUp--now inview_fadeInUp').dequeue();
                    });
                });
            }
        });
    }

    function inview_zoomIn() {
        $('.inview_zoomIn').one('inview', function(event, isInView) {
            $(this).addClass('inview_zoomIn--now');
            if (isInView) {
                $('.inview_zoomIn--now').each(function(i) {
                    $(this).delay(i * 100).queue(function() {
                        $(this).addClass('animated animate__zoomIn').removeClass('inview_zoomIn--now inview_zoomIn').dequeue();
                    });
                });
            }
        });
    }


}

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* スクロールでheader-changeをbodyに
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/

function header_scroll_class_change() {

    var timer = null;
    
    $(window).on('scroll resize', function(){
    if (timer !== null) {
    clearTimeout(timer);
    }
    timer = setTimeout(function() {
    var nowWidth = $(window).width();
    var scrollTop = $(window).scrollTop();
    if (scrollTop >50 ) {$("body").addClass("header-change");}else{$("body").removeClass("header-change");}
    }, 50);
    });
}
    
/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
呼び出し
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
$(function() {
    spToggleBtn_func();
    inview_func();
    backtotop_func();
    smooth_scroll_func();
    header_scroll_class_change();
})
